import { SLICE_REGISTRY } from 'components/storefront/utils/constants';

/**
 * Validates an array of slice configurations using their corresponding component validation methods.
 *
 * @param {Array} slices - Array of slice configuration objects to validate
 * @param {string} slices[].displayType - The type of the slice, must correspond to a key in SLICE_REGISTRY
 * @returns {Array} Array of validation error objects, empty if no errors
 * @returns {number} errors[].index - Zero-based index of the slice that failed validation
 * @returns {string} errors[].displayType - Type of the slice that failed validation
 * @returns {string} errors[].message - Validation error message
 */
const validateSlices = (slices) => {
    const errors = [];

    slices.forEach((slice, index) => {
        const SliceComponent = SLICE_REGISTRY[slice.displayType];

        if (SliceComponent?.validateSlice) {
            const position = index + 1;
            const validationResult = SliceComponent.validateSlice(slice, position);

            if (validationResult.length === 0) {
                return;
            }

            validationResult.forEach((message) => {
                errors.push({
                    index,
                    displayType: slice.displayType,
                    message,
                });
            });
        }
    });

    return errors;
};

export default validateSlices;
